export const PO_LOAD_START = "PO_LOAD_START";
export const PO_LOAD_SUCCESS = "PO_LOAD_SUCCESS";
export const PO_LOAD_FAILURE = "PO_LOAD_FAILURE";

export const PO_EDIT_DATA_SUCCESS = "PO_EDIT_DATA_SUCCESS";
export const PO_EDIT_DATA_FAILURE = "PO_EDIT_DATA_FAILURE";

export const PO_UPLOAD_SUCCESS = "PO_UPLOAD_SUCCESS";
export const PO_SINGLE_UPLOAD_SUCCESS = "PO_SINGLE_UPLOAD_SUCCESS";

export const PO_DATA_LOADER_PROGRESS = "PO_DATA_LOADER_PROGRESS";